import Cookies from "js-cookie";
import { useResponsive } from "../../hooks/useResponsive";
import { useAppSelector } from "../../services/store";
import SidebarRow from "./SidebarRow";
import { useState, useEffect } from "react";

interface SidebarProps {
  className?: string;
}

export const Sidebar = ({ className = "" }: SidebarProps) => {
  const userReducer = useAppSelector((state) => state.userReducer);
  const { isMobile, isTablet } = useResponsive();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const logout = () => {
    // Show confirmation dialog on mobile for better UX
    if (isMobile) {
      const confirmed = confirm("آیا می‌خواهید از حساب کاربری خود خارج شوید؟");
      if (!confirmed) return;
    }

    Cookies.remove("adminToken");
    window.location.reload();
  };

  const handleSidebarItemClick = () => {
    // Close sidebar on mobile when an item is clicked
    if (isMobile) {
      const sidebar = document.querySelector(".sideBarContainer");
      sidebar?.classList.remove("mobile-open");
    }
  };
  return (
    <>
      {(isMobile || isTablet) && (
        <button
          className="mobile-menu-toggle"
          onClick={toggleSidebar}
          aria-label="منوی کناری"
          aria-expanded={sidebarOpen}
        >
          ☰
        </button>
      )}

      {/* Sidebar Backdrop */}
      {(isMobile || isTablet) && sidebarOpen && (
        <div
          className={`sidebar-backdrop ${sidebarOpen ? "show" : ""}`}
          onClick={() => setSidebarOpen(false)}
        />
      )}
      <aside className={`sideBarContainer ${sidebarOpen ? "mobile-open" : ""}`}>
        <div className="sideBar">
          <div className="pic"></div>
          <i
            className="basketSvg"
            role="button"
            tabIndex={0}
            title="سبد خرید"
            onKeyDown={(e) => e.key === "Enter" && handleSidebarItemClick()}
          ></i>
          <i
            className="productSvg activSvg"
            role="button"
            tabIndex={0}
            title="محصولات"
            onKeyDown={(e) => e.key === "Enter" && handleSidebarItemClick()}
          ></i>
          <i
            className="usersSvg activSvg"
            role="button"
            tabIndex={0}
            title="کاربران"
            onKeyDown={(e) => e.key === "Enter" && handleSidebarItemClick()}
          ></i>
          <i
            className="categorySvg"
            role="button"
            tabIndex={0}
            title="دسته‌بندی‌ها"
            onKeyDown={(e) => e.key === "Enter" && handleSidebarItemClick()}
          ></i>
          <i
            className="menuSvg"
            role="button"
            tabIndex={0}
            title="منو"
            onKeyDown={(e) => e.key === "Enter" && handleSidebarItemClick()}
          ></i>
          <i
            className="sidBarExit clickable"
            onClick={logout}
            role="button"
            tabIndex={0}
            title="خروج"
            onKeyDown={(e) => e.key === "Enter" && logout()}
          ></i>
        </div>

        <div className="adminInfoContainer">
          <span className="admininfo">
            <i className="adminSvg"></i>
            <div className="adminNameSection">
              <h6 className="adminName">
                {userReducer?.profile?.name || "مدیر"}
              </h6>
              <p className="adminTitle">ادمین</p>
            </div>
          </span>

          <SidebarRow
            title="سفارشات"
            url="/order/"
            onClick={handleSidebarItemClick}
          />
          <SidebarRow
            title="کاربران"
            url="/User"
            onClick={handleSidebarItemClick}
          />

          {userReducer?.profile?.role == "SUPER_ADMIN" && (
            <>
              <SidebarRow
                title="داشبورد"
                url="/"
                onClick={handleSidebarItemClick}
              />
              <SidebarRow
                title="خدمات"
                url="/Service"
                onClick={handleSidebarItemClick}
              />
              {/*<SidebarRow
                title="پورتفولیو"
                url="/Portfolio"
                onClick={handleSidebarItemClick}
              />*/}
              <SidebarRow
                title="رنگ ها"
                url="/Color"
                onClick={handleSidebarItemClick}
              />
              <SidebarRow
                title="حسابداری"
                url="/Accounting"
                onClick={handleSidebarItemClick}
              />
              <SidebarRow
                title="موارد بازخوردها"
                url="/FeedbackFactor"
                onClick={handleSidebarItemClick}
              />
              <SidebarRow
                title="تخفیف"
                url="/discount"
                onClick={handleSidebarItemClick}
              />
            </>
          )}
        </div>
      </aside>
    </>
  );
};
